import { NgModule } from '@angular/core';

import { PlanItemModule } from 'src/onboarding/shared/components/plan-item/plan-item.module';
import { MaterialModule } from 'src/onboarding/shared/modules/material.module';
import { SharedModule } from 'src/onboarding/shared/modules/shared.module';
import { RockspoonPlanComponent } from './component/rockspoon-plan.component';

@NgModule({
  imports: [
    SharedModule,
    MaterialModule,
    PlanItemModule
  ],
  declarations: [
    RockspoonPlanComponent
  ],
  exports: [
    RockspoonPlanComponent
  ]
})
export class RockspoonPlanModule {}
